// src/plugins/send-mode-switch.plugin.js
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { createDropdown, addListToDropdown } from '@ckeditor/ckeditor5-ui';
import Model from '@ckeditor/ckeditor5-ui/src/model';
import Collection from '@ckeditor/ckeditor5-utils/src/collection';

const LABELS = {
	enterSends: 'Enter to send',
	shiftEnterSends: 'Shift+Enter to send',
	buttonOnly: 'Button to send'
};

export default class SendModeSwitchPlugin extends Plugin {
	static get requires() {
		return [ 'EnterToSendPlugin' ];
	}

	static get pluginName() {
		return 'SendModeSwitchPlugin';
	}

	init() {
		const editor = this.editor;
		const etsp = editor.plugins.get( 'EnterToSendPlugin' );

		editor.ui.componentFactory.add( 'sendMode', locale => {
			const dropdown = createDropdown( locale );

			const getMode = () => etsp && etsp.api ? etsp.api.getMode() : 'enterSends';
			const setButtonLabel = () => {
				const m = getMode();
				dropdown.buttonView.set( {
					label: LABELS[ m ],
					withText: true,
					tooltip: 'Message send mode'
				} );
			};
			setButtonLabel();

			// Build menu
			const ids = [ 'enterSends', 'shiftEnterSends', 'buttonOnly' ];
			const itemDefs = new Collection();
			const modelsById = new Map();

			ids.forEach( id => {
				const model = new Model( {
					label: LABELS[ id ],
					withText: true,
					commandParam: id,
					isOn: id === getMode(), // <-- highlight current
					role: 'menuitemradio' // a11y: radio-like group
				} );
				modelsById.set( id, model );
				itemDefs.add( { type: 'button', model } );
			} );

			addListToDropdown( dropdown, itemDefs );

			// When user picks a mode
			dropdown.on( 'execute', evt => {
				const picked = evt.source && evt.source.commandParam;
				if ( !picked || !etsp || !etsp.api ) {
					return;
				}

				etsp.api.setMode( picked );
				setButtonLabel();
				updateHighlights( picked );
			} );

			// Keep highlight in sync if mode changes elsewhere
			editor.on( 'enterToSend:modeChange', ( evt, { mode } ) => {
				setButtonLabel();
				updateHighlights( mode );
			} );

			// Helper: toggle .ck-on for items
			function updateHighlights( activeId ) {
				ids.forEach( id => {
					const m = modelsById.get( id );
					if ( m ) {
						m.set( 'isOn', id === activeId );
					}
				} );
			}

			return dropdown;
		} );
	}
}
